export const initialAudio = {
	volumeBoost: 1.0,
}
